import { css } from 'aphrodite';
import React from 'react';
import { styleSheet } from '../styles';

interface ISettingGroupProps {
	title: string;
	children: React.ReactNode;
}

export const SettingGroup: React.FC<ISettingGroupProps> = ({ title, children }) => {
	return (
		<div className={css(styleSheet.settingGroup)}>
			<header className={css(styleSheet.settingGroupHeader)}>
				<h5 className={css(styleSheet.settingGroupTitle)}>{title}</h5>
			</header>
			{children}
		</div>
	);
};
